import { LandlineCheckProvider } from 'components/providers/LandlineCheckProvider'

import { ReactNode } from 'react'
import { use100vh } from 'react-div-100vh'

import * as Styled from './styled'
import PaymentProvider from 'components/providers/PaymentProvider'
import Logger from 'services/Logger'

interface AppContainerProps {
  children: ReactNode
}

export default function AppContainer(props: AppContainerProps) {
  return (
    <Styled.AppContainer id="app-root" container sx={{ height: '100vh' }}>
      <LandlineCheckProvider>{props.children}</LandlineCheckProvider>
    </Styled.AppContainer>
  )
}
